import { createBrowserHistory } from 'history';
import { applyMiddleware, compose, createStore } from 'redux';
import { createLogicMiddleware } from 'redux-logic';
import { routerMiddleware } from 'connected-react-router';
import createRootReducer from './reducers';
import rootLogic from './logic';

const logicMiddleware = createLogicMiddleware(rootLogic);

export const history = createBrowserHistory({
    basename: '/admin',
});

export default function configureStore() {
    const store = createStore(
        createRootReducer(history), // root reducer with router state
        //preloadedState,
        compose(
            applyMiddleware(
                routerMiddleware(history), // for dispatching history actions
                logicMiddleware,
            ),
        ),
    );

    return store;
}
